module.exports = __webpack_public_path__ + "img/comment-image.1f976595.svg";